/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Disabled_Alert_TitleInputs */



/**
* | output |
* | --- |
* | "Compliance is turned off" |
*
* @param {Compliance_Disabled_Alert_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_disabled_alert_title = /** @type {((inputs?: Compliance_Disabled_Alert_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Disabled_Alert_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance ist deaktiviert")
	return /** @type {LocalizedString} */ ("Compliance is turned off")
});